import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import withUser from "../hoc/withUser";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Dialog from "@material-ui/core/Dialog";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretSquareDown } from "@fortawesome/free-solid-svg-icons";
import { faCaretSquareUp } from "@fortawesome/free-solid-svg-icons";
import Paper from "@material-ui/core/Paper";
import Create from "@material-ui/icons/Create";
import Layout from "../layouts/Layout";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import WarningIcon from "@material-ui/icons/Warning";
import classNames from "classnames";
import ExifOrientationImg from "react-exif-orientation-img";
//import Img from "react-fix-image-orientation";
import Img from "react-image";
import {
  primaryShade1,
  primaryShade2,
  grey,
  white,
  secondaryShade1,
  secondaryShade6
} from "../styles/color";
import imageCompression from "browser-image-compression";

let platform = "other";
if (window.cordova && window.device.platform === "iOS") {
  platform = "ios";
}

const variantIcon = {
  warning: WarningIcon
};
const styles1 = theme => ({
  root: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  modal: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  paperFullWidth: {
    fullWidth: true
  },
  input: {
    marginLeft: 8,
    flex: 1
  },
  iconButton: {
    padding: 10
  },
  divider: {
    width: 1,
    height: 28,
    margin: 4
  },
  avatar: {
    backgroundColor: secondaryShade1,
    color: secondaryShade6
  },
  warning: {
    backgroundColor: theme.palette.error.dark
  },
  icon: {
    fontSize: 20
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit
  },
  message: {
    display: "flex",
    alignItems: "center"
  }
});
const DialogTitle = withStyles(theme => ({
  root: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit * 2
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing.unit,
    top: theme.spacing.unit,
    color: theme.palette.grey
  }
}))(props => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="Close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing.unit * 2
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing.unit
  }
}))(MuiDialogActions);

const styles = {
  avatar: {
    margin: 10
  },
  bigAvatar: {
    marginTop: -40,
    width: 75,
    height: 75,
    borderRadius: "50%"
  }
};

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props;
  const Icon = variantIcon[variant];

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      {...other}
    />
  );
}

MySnackbarContent.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["warning"]).isRequired
};

const MySnackbarContentWrapper = withStyles(styles1)(MySnackbarContent);

class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      dialogOpen: false,
      mode: false,
      manageUnit: "",
      productName: "",
      bardanaConditionName: null,
      dealQualityName: null,
      dispatchConditionName: null,
      unitName: "",
      transporterName: "",
      manageProduct: "",
      manageCustomer: "",
      scroll: "paper",
      openDialogue: false,
      snackbarMessage: [],
      openSnackBar: false,
      name: "",
      address: "",
      email: "",
      phone: "",
      imageURL: "",
      organisationId: ""
    };
  }
  componentWillMount() {
    this.initializeData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.initializeData(nextProps);
  }
  initializeData = whichProps => {
    if (whichProps.currentUser.length > 0) {
      this.setState({
        name: whichProps.currentUser[0].name,
        address: whichProps.currentUser[0].address,
        email: whichProps.currentUser[0].email,
        imageURL: whichProps.currentUser[0].imageURL
      });
      if (whichProps.currentUser[0].phoneNumber !== ("" || null || undefined)) {
        this.setState({ phone: whichProps.currentUser[0].phoneNumber });
      }
    }
    if (whichProps.organisations !== undefined) {
      this.setState({
        organisationId: whichProps.organisations.organisationId
      });
    }
  };
  handleClickOpen = scroll => () => {
    this.setState({ open: true, scroll });
  };

  handleDialogOpen = secondMode => {
    this.setState({ dialogOpen: true, secondMode });
  };

  handleListItemClick = value => {
    this.props.onClose(value);
  };

  handleClickOpenDialog = mode => {
    this.setState({ open: true, mode });
  };

  handleDialogClose = () => {
    this.setState({ open: false });
  };

  seconDilogClose = () => {
    this.setState({
      dialogOpen: false,
      open: false,
      transporterName: "",
      unitName: "",
      productName: "",
      bardanaConditionName: null,
      dealQualityName: null,
      dispatchConditionName: null
    });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  };
  handleOpenSnackBar = snackbarMessage => {
    this.setState({ openSnackBar: true, snackbarMessage });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ openSnackBar: false });
  };
  render() {
    const {
      mode,
      secondMode,
      unitName,
      productName,
      snackbarMessage,
      openSnackBar,
      transporterName,
      name,
      imageURL,
      phone,
      email,
      organisationId,
      bardanaConditionName,
      dealQualityName,
      dispatchConditionName
    } = this.state;
    const {
      user,
      addUnit,
      addProduct,
      products,
      units,
      customers,
      transporters,
      addTransporter,
      addBardanaCondition,
      addDealQuality,
      addDispatchConditon,
      bardanaCondition,
      dealQuality,
      dispatchCondition
    } = this.props;
    return (
      <Layout
        position="fixed"
        bottomNavigation={true}
        appBar
        appBarTitle="SETTINGS"
        appBarRightIcon={true}
        selectedValue={2}
      >
        <div
          style={{
            margin: "65px 0px 60px 0px",
            padding: "0px 10px 0px 10px",
            height: "80%",
            zIndex: "inherit",
            overflow: "scroll"
          }}
        >
          <div
            style={{
              width: "100%",
              marginTop: "40px",
              borderRadius: "7px"
            }}
          >
            <Paper
              elevation={1}
              style={{ height: "30%", border: "1px solid orange" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-around"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: -40
                  }}
                >
                  {!imageURL ? (
                    <Avatar
                      className="AvatarImg"
                      style={{
                        alignItems: "center",
                        background: primaryShade2,
                        color: "black",
                        fontSize: "1.7em",
                        width: 75,
                        height: 75,
                        borderRadius: "50%"
                      }}
                    >
                      {name.charAt(0).toUpperCase()}
                    </Avatar>
                  ) : platform === "ios" ? (
                    <Img
                      className="IOSImg"
                      src={imageURL}
                      style={{
                        alignItems: "center",
                        background: primaryShade2,
                        color: "black",
                        fontSize: "3em",
                        width: 75,
                        height: 75,
                        borderRadius: "50%"
                      }}
                      alt={name.charAt(0).toUpperCase()}
                    />
                  ) : (
                    <ExifOrientationImg
                      className="ANDRImg"
                      src={imageURL}
                      style={{
                        alignItems: "center",
                        background: primaryShade2,
                        color: "black",
                        fontSize: "3em",
                        width: 75,
                        height: 75,
                        borderRadius: "50%",
                        imageOrientation: `from-image`
                      }}
                      alt={name.charAt(0).toUpperCase()}
                    />
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px"
                  }}
                >
                  <table style={{ height: "100px" }}>
                    <tr>
                      <td>Name</td>
                      <td />
                      <td>
                        <span style={{ color: grey }}>{name}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Email</td>
                      <td />
                      <td>
                        <span style={{ color: grey }}>{email}</span>
                      </td>
                    </tr>
                    <tr>
                      <td>Phone</td>
                      <td />
                      <td>
                        <span style={{ color: grey }}>{phone}</span>
                      </td>
                    </tr>
                  </table>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-around",
                    alignItems: "center",
                    marginBottom: "10px"
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={e => {
                      e.preventDefault();
                      this.props.history.push("/settings/viewProfile");
                    }}
                    style={{
                      backgroundColor: primaryShade1,
                      borderRadius: "20px",
                      fontSize: "0.68rem",
                      height: "30%"
                    }}
                  >
                    <span style={{ color: white }}>View Profile</span>
                  </Button>
                  <Button
                    variant="contained"
                    onClick={e => {
                      e.preventDefault();
                      this.props.history.push("/settings/updateInfo");
                    }}
                    style={{
                      backgroundColor: primaryShade1,
                      borderRadius: "20px",
                      fontSize: "0.68rem",
                      height: "25%",
                      alignItems: "center"
                    }}
                  >
                    <Create style={{ fontSize: "1.05rem", color: white }} />
                    <span style={{ color: white }}>Update Info</span>
                  </Button>
                </div>
              </div>
            </Paper>
          </div>
          <div
            style={{
              marginTop: "25px",
              width: "100%",
              height: "30%",
              maxHeight: "30%",
              overflow: "scroll"
            }}
          >
            <Paper elevation={1} style={{ border: "1px solid orange" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "5px",
                  alignItems: "center"
                }}
              >
                <div>Manage Units</div>
                <div>
                  <FontAwesomeIcon
                    style={{ color: primaryShade1 }}
                    icon={faCaretSquareDown}
                    size={"2x"}
                    onClick={e => {
                      e.preventDefault();
                      this.handleClickOpenDialog("manageUnit");
                    }}
                  />
                </div>
              </div>
            </Paper>

            <div style={{ marginTop: "25px", width: "100%" }}>
              <Paper elevation={1} style={{ border: "1px solid orange" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px",
                    alignItems: "center"
                  }}
                >
                  <div>Manage Customer</div>
                  <div>
                    <FontAwesomeIcon
                      style={{ color: primaryShade1 }}
                      icon={faCaretSquareDown}
                      size={"2x"}
                      onClick={e => {
                        e.preventDefault();
                        this.handleClickOpenDialog("manageCustomer");
                      }}
                    />
                  </div>
                </div>
              </Paper>
            </div>
            <div style={{ marginTop: "25px", width: "100%" }}>
              <Paper elevation={1} style={{ border: "1px solid orange" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "5px",
                    alignItems: "center"
                  }}
                >
                  <div>Manage Products</div>
                  <div>
                    <FontAwesomeIcon
                      style={{ color: primaryShade1 }}
                      icon={faCaretSquareDown}
                      size={"2x"}
                      onClick={e => {
                        e.preventDefault();
                        this.handleClickOpenDialog("manageProduct");
                      }}
                    />
                  </div>
                </div>
              </Paper>
              <div style={{ marginTop: "25px", width: "100%" }}>
                <Paper elevation={1} style={{ border: "1px solid orange" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      padding: "5px",
                      alignItems: "center"
                    }}
                  >
                    <div>Manage Transporter</div>
                    <div>
                      <FontAwesomeIcon
                        style={{ color: primaryShade1 }}
                        icon={faCaretSquareDown}
                        size={"2x"}
                        onClick={e => {
                          e.preventDefault();
                          this.handleClickOpenDialog("manageTransporter");
                        }}
                      />
                    </div>
                  </div>
                </Paper>{" "}
                <div style={{ marginTop: "25px", width: "100%" }}>
                  <Paper elevation={1} style={{ border: "1px solid orange" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "5px",
                        alignItems: "center"
                      }}
                    >
                      <div>Manage Bardana Condition</div>
                      <div>
                        <FontAwesomeIcon
                          style={{ color: primaryShade1 }}
                          icon={faCaretSquareDown}
                          size={"2x"}
                          onClick={e => {
                            e.preventDefault();
                            this.handleClickOpenDialog(
                              "manageBardanaCondition"
                            );
                          }}
                        />
                      </div>
                    </div>
                  </Paper>{" "}
                  <div style={{ marginTop: "25px", width: "100%" }}>
                    <Paper elevation={1} style={{ border: "1px solid orange" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          padding: "5px",
                          alignItems: "center"
                        }}
                      >
                        <div>Manage Quality</div>
                        <div>
                          <FontAwesomeIcon
                            style={{ color: primaryShade1 }}
                            icon={faCaretSquareDown}
                            size={"2x"}
                            onClick={e => {
                              e.preventDefault();
                              this.handleClickOpenDialog("manageQuality");
                            }}
                          />
                        </div>
                      </div>
                    </Paper>
                    <div style={{ marginTop: "25px", width: "100%" }}>
                      <Paper
                        elevation={1}
                        style={{ border: "1px solid orange" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "5px",
                            alignItems: "center"
                          }}
                        >
                          <div>Manage Dispatch Condition</div>
                          <div>
                            <FontAwesomeIcon
                              style={{ color: primaryShade1 }}
                              icon={faCaretSquareDown}
                              size={"2x"}
                              onClick={e => {
                                e.preventDefault();
                                this.handleClickOpenDialog(
                                  "manageDispatchCondition"
                                );
                              }}
                            />
                          </div>
                        </div>
                      </Paper>
                      <div style={{ marginTop: "25px", width: "100%" }}>
                        <Paper
                          elevation={1}
                          style={{ border: "1px solid orange" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              padding: "5px",
                              alignItems: "center"
                            }}
                          >
                            <div>Manage Invoice Print Details</div>
                            <div>
                              <FontAwesomeIcon
                                style={{ color: primaryShade1 }}
                                icon={faCaretSquareDown}
                                size={"2x"}
                                onClick={e => {
                                  e.preventDefault();
                                  this.handleClickOpenDialog(
                                    "manageInvoicePrint"
                                  );
                                }}
                              />
                            </div>
                          </div>
                        </Paper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              margin: "10px 0px 10px 0px",
              width: "100%",
              padding: "0px 10px 0px 10px"
            }}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={e => {
                e.preventDefault();
                this.props.logOut();
                this.props.history.push("/");
              }}
              style={{ backgroundColor: primaryShade1, borderRadius: "7px" }}
            >
              <span style={{ color: white }}>Log out</span>
            </Button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              color: grey,
              marginBottom: "10px"
            }}
          >
            <span>Version : 1.0.27</span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              color: primaryShade1
            }}
          >
            <span
              onClick={e => {
                e.preventDefault();
                this.props.history.push("/privacyPolicy");
              }}
              style={{ textDecoration: "underline" }}
            >
              Privacy Policy
            </span>
          </div>
          <Dialog
            onClose={this.handleDialogClose}
            onBackdropClick={this.handleDialogClose}
            aria-labelledby="customized-dialog-title"
            open={this.state.open}
            scroll={this.state.scroll}
          >
            <AppBar style={{ position: "relative", color: white }}>
              <Toolbar>
                <Typography variant="h6" color="inherit">
                  {mode === "manageCustomer"
                    ? "Manage Customer"
                    : mode === "manageUnit"
                    ? "Manage Unit"
                    : mode === "manageProduct"
                    ? "Manage Products"
                    : mode === "manageTransporter"
                    ? " Manage Transporter "
                    : mode === "manageInvoicePrint"
                    ? " Manage Invoice Print Details "
                    : mode === "manageBardanaCondition"
                    ? "Manage Bardana Condition"
                    : mode === "manageQuality"
                    ? "Manage Quality"
                    : mode === "manageDispatchCondition"
                    ? "Manage Dispatch Condition"
                    : ""}
                </Typography>
                <Button
                  color="inherit"
                  onClick={e => {
                    e.preventDefault();
                    this.handleDialogClose();
                  }}
                >
                  <FontAwesomeIcon
                    style={{ color: primaryShade1 }}
                    icon={faCaretSquareUp}
                    size={"2x"}
                  />
                </Button>
              </Toolbar>
            </AppBar>
            <DialogContent>
              {mode === "manageCustomer" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.props.history.push(
                            `/addCustomer/${this.props.user.uid}`
                          );
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="add customer" />
                      </ListItem>
                      {customers.map(data => (
                        <ListItem
                          button
                          onClick={e => {
                            e.preventDefault();
                            this.props.history.push(
                              `/updateCustomer/${data.id}`
                            );
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              src={data.imageURL}
                              alt=""
                              style={{ backgroundColor: primaryShade1 }}
                            >
                              {data.name
                                ? data.name.substring(0, 1).toUpperCase()
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.name} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageInvoicePrint" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.props.history.push(
                            `/addInvoicePrintData/${this.props.user.uid}`
                          );
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Add Invoice Print Details" />
                      </ListItem>
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageProduct" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.handleDialogOpen("product");
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="add product" />
                      </ListItem>
                      {products.map(data => (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar
                              src={data.imageURL}
                              alt=""
                              style={{ backgroundColor: primaryShade1 }}
                            >
                              {data.productName
                                ? data.productName.substring(0, 1).toUpperCase()
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.productName} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageUnit" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.handleDialogOpen("unit");
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="add unit" />
                      </ListItem>
                      {units.map(data => (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar
                              src={data.imageURL}
                              alt=""
                              style={{ backgroundColor: primaryShade1 }}
                            >
                              {data.unitName
                                ? data.unitName.substring(0, 1).toUpperCase()
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.unitName} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageBardanaCondition" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.handleDialogOpen("bardanaCondition");
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Add Bardana Condition" />
                      </ListItem>
                      {bardanaCondition.map(data => (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar
                              alt=""
                              style={{ backgroundColor: primaryShade1 }}
                            >
                              {data.name
                                ? data.name.substring(0, 1).toUpperCase()
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.name} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageQuality" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.handleDialogOpen("dealQuality");
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Add Quality" />
                      </ListItem>
                      {dealQuality.map(data => (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar
                              alt=""
                              style={{ backgroundColor: primaryShade1 }}
                            >
                              {data.name
                                ? data.name.substring(0, 1).toUpperCase()
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.name} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageDispatchCondition" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.handleDialogOpen("dispatchCondition");
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="Add Dispatch Condition" />
                      </ListItem>
                      {dispatchCondition.map(data => (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar
                              alt=""
                              style={{ backgroundColor: primaryShade1 }}
                            >
                              {data.name
                                ? [...new Set(data.name.match(/(\d+)/))]
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.name} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : mode === "manageTransporter" ? (
                <Typography gutterBottom>
                  <div>
                    <List>
                      <ListItem
                        button
                        onClick={e => {
                          e.preventDefault();
                          this.handleDialogOpen("transporter");
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar>
                            <AddIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary="add transporter" />
                      </ListItem>
                      {transporters.map(data => (
                        <ListItem>
                          <ListItemAvatar>
                            <Avatar style={{ backgroundColor: primaryShade1 }}>
                              {data.transporterName
                                ? data.transporterName
                                    .substring(0, 1)
                                    .toUpperCase()
                                : ""}
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText primary={data.transporterName} />
                        </ListItem>
                      ))}
                    </List>
                  </div>
                </Typography>
              ) : null}
            </DialogContent>
          </Dialog>

          {/* Open Second Dialog */}
          <Dialog
            open={this.state.dialogOpen}
            onClose={this.seconDilogClose}
            aria-labelledby="form-dialog-title"
          >
            {secondMode === "product" ? (
              <div>
                <DialogTitle id="form-dialog-title">Add Product</DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name="productName"
                    onChange={this.handleChange("productName")}
                    label="Product Name"
                    type="text"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.seconDilogClose}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={e => {
                      e.preventDefault();
                      if (productName !== "") {
                        const product = {
                          productName: productName,
                          userId: user.uid,
                          organisationId: organisationId,
                          createdAt: new Date()
                        };
                        addProduct(product);
                        this.seconDilogClose();
                      } else {
                        this.handleOpenSnackBar("Input Proper Product Name");
                      }
                    }}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </div>
            ) : secondMode === "unit" ? (
              <div>
                <DialogTitle id="form-dialog-title">Add Unit</DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name="unitName"
                    onChange={this.handleChange("unitName")}
                    label="Unit Name"
                    type="text"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.seconDilogClose}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={e => {
                      e.preventDefault();
                      if (unitName !== "") {
                        const unit = {
                          unitName: unitName,
                          userId: user.uid,
                          organisationId: organisationId,
                          createdAt: new Date()
                        };
                        addUnit(unit);
                        this.seconDilogClose();
                      } else {
                        this.handleOpenSnackBar("Input Proper Unit Name");
                      }
                    }}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </div>
            ) : secondMode === "bardanaCondition" ? (
              <div>
                <DialogTitle id="form-dialog-title">
                  Add Bardana Condition
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name="bardanaConditionName"
                    onChange={this.handleChange("bardanaConditionName")}
                    label="Bardana Condition Name"
                    type="text"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.seconDilogClose}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={e => {
                      e.preventDefault();
                      if (bardanaConditionName !== "") {
                        const bardanaCondition = {
                          name: bardanaConditionName,
                          userId: user.uid,
                          organisationId: organisationId,
                          createdAt: new Date()
                        };
                        addBardanaCondition(bardanaCondition);
                        this.seconDilogClose();
                      } else {
                        this.handleOpenSnackBar(
                          "Input Proper Bardana Condition"
                        );
                      }
                    }}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </div>
            ) : secondMode === "dealQuality" ? (
              <div>
                <DialogTitle id="form-dialog-title">Add Quality</DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name="dealQualityName"
                    onChange={this.handleChange("dealQualityName")}
                    label="Quality Name"
                    type="text"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.seconDilogClose}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={e => {
                      e.preventDefault();
                      if (dealQualityName !== "") {
                        const dealQuality = {
                          name: dealQualityName,
                          userId: user.uid,
                          organisationId: organisationId,
                          createdAt: new Date()
                        };
                        addDealQuality(dealQuality);
                        this.seconDilogClose();
                      } else {
                        this.handleOpenSnackBar("Input Proper Quality Name");
                      }
                    }}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </div>
            ) : secondMode === "dispatchCondition" ? (
              <div>
                <DialogTitle id="form-dialog-title">
                  Add Dispatch Condition
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name="dispatchConditionName"
                    onChange={this.handleChange("dispatchConditionName")}
                    label="Dispatch Condition Name"
                    type="text"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.seconDilogClose}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={e => {
                      e.preventDefault();
                      if (dispatchConditionName !== "") {
                        const dispatchCondition = {
                          name: dispatchConditionName,
                          userId: user.uid,
                          organisationId: organisationId,
                          createdAt: new Date()
                        };
                        addDispatchConditon(dispatchCondition);
                        this.seconDilogClose();
                      } else {
                        this.handleOpenSnackBar(
                          "Input Proper Dispatch Condition"
                        );
                      }
                    }}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </div>
            ) : (
              <div>
                <DialogTitle id="form-dialog-title">
                  Add Transporter
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    name="transporterName"
                    onChange={this.handleChange("transporterName")}
                    label="Transporter Name"
                    type="text"
                    fullWidth
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.seconDilogClose}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={e => {
                      e.preventDefault();
                      if (transporterName !== "") {
                        const transporter = {
                          transporterName: transporterName,
                          userId: user.uid,
                          organisationId: organisationId,
                          createdAt: new Date()
                        };
                        addTransporter(transporter);
                        this.seconDilogClose();
                      } else {
                        this.handleOpenSnackBar(
                          "Input Proper Transporter Name"
                        );
                      }
                    }}
                    style={{ backgroundColor: primaryShade1, color: white }}
                  >
                    Add
                  </Button>
                </DialogActions>
              </div>
            )}
          </Dialog>

          <Snackbar
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            open={openSnackBar}
            autoHideDuration={3000}
            onClose={this.handleClose}
          >
            <MySnackbarContentWrapper
              variant="warning"
              message={snackbarMessage}
            />
          </Snackbar>
        </div>
      </Layout>
    );
  }
}
Settings.propTypes = {
  fullScreen: PropTypes.bool.isRequired
};

export default withRouter(withUser(Settings));
